// src/index.ts
var PiniaDebounce = (debounce) => ({ options, store }) => {
  const { debounce: debounceOptions } = options;
  if (debounceOptions) {
    return Object.keys(debounceOptions).reduce((debouncedActions, action) => {
      debouncedActions[action] = debounce(store[action], debounceOptions[action]);
      return debouncedActions;
    }, {});
  }
};
export {
  PiniaDebounce
};
